import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Container, Reveal, SectionLabel } from "../components/primitives";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import Seo from "../components/Seo";

const faqs = [
  { q: "How long does it take to build my website?", a: "Most Professional and Premium websites are delivered within 72 hours of completing onboarding. Starter sites are typically ready within a few business days." },
  { q: "What do I need to provide?", a: "After payment you'll complete a simple onboarding form — your business info, logo, photos, brand colors and preferences. Our AI assistant can even help draft your copy." },
  { q: "Do you offer revisions?", a: "Yes. Starter includes 1 revision, Professional includes 2, and Premium includes 3 revisions so we can perfect your site." },
  { q: "What is Website Care?", a: "Website Care is our $99/month plan covering hosting, security, backups, minor updates and technical maintenance so your site stays fast, safe and current." },
  { q: "Will my website work on mobile?", a: "Absolutely. Every website we build is fully responsive and optimized for phones, tablets and desktops." },
  { q: "Do you help with SEO?", a: "Yes. Every site includes SEO-friendly titles, meta descriptions, Open Graph tags, sitemaps and schema markup so local customers can find you." },
  { q: "How do payments work?", a: "Payments are securely processed by Stripe. We never store your card details. Website packages are one-time payments; Website Care is a monthly subscription." },
  { q: "Can I update the website myself later?", a: "Yes — with Website Care our team handles minor updates for you. For larger changes we offer additional packages." },
];

export default function FAQ() {
  const navigate = useNavigate();
  return (
    <div data-testid="faq-page" className="pt-32">
      <Seo page="faq" />
      <Container className="max-w-3xl pb-24">
        <Reveal>
          <SectionLabel>FAQ</SectionLabel>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold tracking-tighter text-[#F3EDDC]">Questions, answered</h1>
          <p className="mt-5 text-lg text-[#B7AF98]">Everything you need to know about working with WebLaunch Studio.</p>
        </Reveal>
        <Reveal delay={100}>
          <Accordion type="single" collapsible className="mt-10">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-white/10">
                <AccordionTrigger className="text-left font-display text-lg font-semibold text-[#F3EDDC] hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="text-[#B7AF98] leading-relaxed text-base">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
        <div className="mt-14 rounded-3xl bg-[#0c0c0d] border border-white/10 p-8 text-center">
          <h2 className="font-display text-2xl font-bold text-[#F3EDDC]">Still have questions?</h2>
          <p className="mt-2 text-[#B7AF98]">We're happy to help you choose the right plan.</p>
          <Button onClick={() => navigate("/contact")} className="mt-5 rounded-full bg-[#C9A227] hover:bg-[#B0891C] text-black h-12 px-7">Contact us</Button>
        </div>
      </Container>
    </div>
  );
}
